import { StorageKeyEnum } from 'src/app/core/StorageKeyEnum';
import { LoginModel } from './../../models/login.model';
const navRoutes: navRoute[] = [
  {
    name: "Dashboard",
    url: ["/dashboard"],
    iconUrl: "assets/images/application-icons/dashboard-icon.svg",
    hasPermission: true,
    permissionName: 'Dashboard'
  },
  {
    name: "Inventory",
    url: ["inventory"],
    iconUrl: "assets/images/application-icons/inventory-icon.png",
    permissionName: 'Inventory',
    permissions: "isPlanYard",
    children: [
      {
        name: "SKUs",
        url: ["/inventory/skus"],
        permissionName: 'SKUs',
      },
      {
        name: "Products",
        url: ["/inventory/products"],
        permissionName: 'Products',
      },
      {
        name: "Vendor Items",
        url: ["/inventory/items"],
        permissionName: 'VendorItems',
      },
      {
        name: "Vendors",
        url: ["/inventory/vendors"],
        permissionName: 'Vendors',
      },

      /* {
         name: "Sync History",
         url: ["/inventory/sync-history/"],
       },*/

    ],
  },
  {
    name: "Purchasing",
    url: ["forecasting"],
    enrollmentAction: false,
    iconUrl: "assets/images/application-icons/planyard-icon-v2.svg",
    permissionName: 'Purchasing',
    permissions: "isPlanYard",
    children: [
      {
        name: "Forecasting",
        url: ["/forecasting/purchasing"],
        permissionName: 'Forecasting',
      },
      {
        name: "Purchase Orders",
        url: ["/forecasting/purchase-orders"],
        permissionName: 'PurchaseOrders',
      },
      {
        name: "Forecasting by sku",
        url: ["/forecasting/purchasing-by-sku"],
        permissionName: 'Forecastingbysku',
      }
    ], 
  },
  {
    name: "Shipping",
    url: ["shipyard"],
    iconUrl: "assets/images/application-icons/shipyard-icon.svg",
    hasPermission: true,
    freemium: true,
    permissionName: 'Shipping',
    children: [
      {
        name: "Replenish",
        url: ["/shipyard/replenish"],
        permissionName: 'Replenish',
      },
      {
        name: "Shipments",
        url: ["/shipyard/shipments"],
        permissionName: 'Shipments',
      },
      {
        name: "Claims",
        url: ["/shipyard/claim-center"],
        permissionName: 'claimCenter',
        isBeta: true,
      },
      // {
      //   name: "Shipment Monitor",
      //   url: ["/shipyard/shipment-monitor"],
      //   permissionName: 'shipmentMonitor',
      // },
    ],
  },
  // logistic route start .....
  {
    name: "Logistics",
    url: ["logistic"],
    iconUrl: "assets/images/application-icons/planyard-icon-v2.svg",
    permissionName: 'Logistics',
    permissions: "isPlanYard",
    children: [
      {
        name: "Warehouses",
        url: ["/logistic/wh-location"],
        permissionName: 'Warehouses',
      },
      {
        name: "History",
        url: ["/logistic/history"],
        permissionName: 'LogisticHistory',
      },
    ],
  },
  // logistic end .....
  {
    name: "Pricing",
    url: ["priceyard"],
    iconUrl: "assets/images/application-icons/priceyard-icon.svg",
    permissions: "isPriceYard",
    permissionName: 'Pricing',
    children: [
      {
        name: "Pricing Pulse",
        url: ["/priceyard/pricing-pulse"]
      },
      {
        name: "Pricing List",
        url: ["/priceyard/pricing-list"],
        permissionName: 'PricingList',
      },
      {
        name: "models",
        url: ["/priceyard/models"],
        permissionName: 'Models',
      },
      {
        name: "History",
        url: ["/priceyard/history"],
        permissionName: 'History',
      },
      {
        name: "Sellers",
        url: ["/priceyard/sellers"],
        permissionName: 'Sellers',
      },
      {
        name: "Cost Settings",
        url: ["/priceyard/settings"],
        permissionName: 'CostSettings',
      },
      {
        name: "Price Calculator",
        url: ["/priceyard/price-calculator"]
      },
      {
        name: "Fee Monitor",
        url: ["/priceyard/fee-monitor"]
      },
    ],
  },

  {
    name: "Orders",
    url: ["forecasting"],
    iconUrl: "assets/images/application-icons/planyard-icon-v2.svg",
    permissionName: 'Orders',
    permissions: "isPlanYard",
    children: [
      {
        name: "Orders",
        url: ["/forecasting/orders"],
        permissionName: 'SubOrders',
      },
      {
        name: "Fulfilment",
        url: ["/forecasting/fbm-orders"],
        iconUrl: "assets/images/application-icons/arrow-icon.svg",
        isBeta: true,
        permissionName: 'Fulfilment',
        permissions: "isPlanYard",
        children: [
          {
            name: "Orders",
            url: ["/forecasting/fbm-orders/orders"],
            permissionName: 'FulfilmentOrders',
          }, {
            name: "batches",
            url: ["/forecasting/fbm-orders/batches"],
            permissionName: 'Batches',
          }
        ]
      }
    ],
  },
  {
    name: "Analytics",
    url: ["analytics"],
    iconUrl: "assets/images/application-icons/analytics-icon.svg",
    isNonStandard: true,
    //isBeta: true,
   // permissions: "isShipyard",
    permissionName: 'Analytics',
    //permissions: "isPlanYard",
    children: [
      {
        name: "KPI dashboard",
        url:["analytics/kpi"],
        permissionName: 'KPIs',
      },
      /*{
        name: "Sales Report",
        url: [],
        children: [
          {
            name:"Order List",
            url:["analytics/sales-order-list"]
          },
        ]
      },*/
      {
        name: "Profit Reports",
        url: [],
        permissionName: 'ProfitReports',
        children: [
          {
            name: "By Date",
            url: ["/analytics/profit-by-date"],
            permissionName: 'ProfitByDate',
          },
          {
            name: "By Merchandise",
            url: ["/analytics/profit-by-sku"],
            permissionName: 'ProfitBySKU',
          },
      
          // {
          //   name: "Profit By SKU & date",
          //   url: ["/analytics/profit-by-sku-date"],
          // },
          // {
          //   name: "Profit vendor",
          //   url: ["/analytics/profit-vendor"],
          // },
          // {
          //   name: "Profit Buyer",
          //   url: ["/analytics/profit-buyer"],
          // },
          // {
          //   name: "Profit by channel",
          //   url: ["/analytics/profit-by-channel"],
          // },
          // {
          //   name: "P&L",
          //   url: ["/analytics/P&L"],
          // },
        ]
      },
      {
        name: "Sales Reports",
        url: [],
        permissionName: 'SalesReports',
        children: [
          {
            name: "sales by product",
            url: ["/analytics/profit-by-product-date"],
            permissionName: 'Salesbyproduct',
          },
          {
            name:"Order List",
            url:["analytics/sales-order-list"],
            permissionName: 'OrderList',
          },
          {
            name: "sales trend",
            url: ["/analytics/sales-trend"],
            permissionName: 'SalesTrends',
          }
        ]
      },
      {
        name: "Monthly Snapshots",
        url: [],
        permissionName: 'MonthlySnapshots',
        children: [
          {
            name:"Inventory Summary",
            url:["/analytics/inventory-summary"],
            permissionName: 'InventorySummary',
          },
          {
            name:"Po's Summary",
            url:["/analytics/po-summary"],
            permissionName: 'PoSummary',
          },
        ]
      },
      {
        name: "Settlements",
        url: ["/analytics/settlements"],
        permissionName: "Settlements"
      },
      {
        name: "Cost Details",
        url: ["/analytics/cost-details"],
        permissionName: "CostDetails"
      },
      {
        name: "P&L",
        url: ["/analytics/P&L"],
        permissionName: "Pl"
      },
      {
        name: "Stock Holding",
        url: ["/analytics/stock-holding"],
        permissionName: "StockHolding"
       },
    ],
  },
  {
    name: "Settings",
    url: ["settings"],
    iconUrl: "assets/images/application-icons/settings-icon-v2.svg",
    permissionName: 'Settings',
    children: [
      {
        name: "Account",
        url: ["/settings/account"],
        permissionName: 'Account',
      },
      {
        name: "Integrations",
        url: ["/settings/integrations"],
        permissionName: 'Integrations',
      },
      {
        name: "Billing",
        url: ["/settings/billing"],
        permissionName: 'Billing',
      },
      {
        name: "System Settings",
        url: ["/settings/system-settings"],
        permissionName: 'SystemSettings',
      },
    ],
  },
];

export default navRoutes;

export const allPermissions = ["isPriceYard", "isShipyard", "isPlanYard","isNetYard"];
const usersAllPermissions = (user: LoginModel): string[] => allPermissions
  .filter(p => user[p])
  .map((p) => p);

export const isOnlyPermission = (user: LoginModel, permission: string) => {
  const onlyPermissions = usersAllPermissions(user).filter(
    (p) => p !== permission
  );
  return !onlyPermissions.length;
};

export const permissionCount = (user: LoginModel) => {
  return usersAllPermissions(user).length;
};

export const hasPermission = (user: LoginModel, permission: string) => {
  return usersAllPermissions(user).filter(
    (p) => p === permission
  ).length;
};

export interface navRoute {
  name: string;
  url: string[];
  iconUrl?: string;
  children?: navRoute[];
  permissions?: string;
  isBeta?: boolean;
  excludeIfOnly?: string;
  isActive?: boolean;
  freemium?: boolean;
  hasPermission?: boolean;
  grandChild?: navRoute[];
  isNonStandard?:boolean;
  permissionName?: string;
  hasAccess?: boolean;
  isComing?:boolean;
  openChildIndex?: number;
  enrollmentAction?:boolean;
}
